import useDemoHelper from "./useDemoHelper";
import step11 from "../../../../../assets/demo/emergency/1.1.mp3";
import step12 from "../../../../../assets/demo/emergency/1.2.mp3";
import step13 from "../../../../../assets/demo/emergency/1.3.mp3";
import isNull from "../../../../../mixin/isNull";

window.sound = new Audio();

export default function () {
    const demoHelper = useDemoHelper();

    const flashAppointment = () => {
        const appointmentInput = document.querySelector('[data-test="input-appointment"]');

        demoHelper.flash(appointmentInput, 5);
    }

    const completeLetMessage = async visual => {
        demoHelper.click('[data-test="button-menu"]');

        await demoHelper.sleep(1000);
        demoHelper.click('[data-test="menu-let-message"]');
        await demoHelper.sleep(500);

        if (visual) {
            await demoHelper.type(document.querySelector('[data-test="textarea-company-comment"]').getElementsByTagName("textarea")[0], "Mon message");

            await demoHelper.sleep(500);

            demoHelper.click('[data-test="button-send-message"]');
        } else {
            await demoHelper.sleep(3000);

            if (!isNull(document.getElementsByClassName("MuiFab-warning")?.[0])) {
                document.getElementsByClassName("MuiFab-warning")[0]?.click();
            }
        }
    }

    return {
        async launch(audio = true, visual = true) {
            demoHelper.lockInteract();

            // 24 seconds
            window.sound.src = step11;
            window.sound.play();

            await demoHelper.sleep(10000);

            flashAppointment();

            await demoHelper.sleep(15000);

            // 16 seconds
            window.sound.src = step12;
            window.sound.play();

            await demoHelper.sleep(7000);

            await completeLetMessage(visual);

            await demoHelper.sleep(1000);

            // 4 seconds
            window.sound.src = step13;
            window.sound.play();

            demoHelper.unlockInteract();
        }
    }
}